import { round } from 'lodash';
import { assertIsNumberOrNull } from '../../helpers/numberHelpers';
import { DesignRoomDetailsFormModel } from '../shared/quote-or-design-form/rooms/designRoomDetailsFormModel';

export type CreateUpdateDesignRoomDetailsDto = {
  unheatedAreaInMetresSquared: number | null;
  voidAreaInMetresSquared: number | null;
  pipesPerPort: number | null;
  manifoldDistanceInMetres: number | null;
  verticalRunbackInMetres: number | null;
  estimatedLengthOfEachPipeInMetres: number | null;
  drawnLengthInMetres: number | null;
  oversupplyLengthInMetres: number | null;
  peripheralAreaInMetresSquared: number | null;
  turnPanelQuantity: number | null;
  straightPanelQuantity: number | null;
  plateAreaInMetresSquared: number | null;
  hasPanelsForUnheatedArea: boolean;
  temperatureDeltaInDegreesCelsius: number | null;
  maximumTemperatureInDegreesCelsius: number | null;
  screedDetails: CreateUpdateRoomScreedDetailsDto | null;
};

export type CreateUpdateRoomScreedDetailsDto = {
  screedConductivity: number | null;
  thicknessOfScreedAbovePipeInMillimetres: number | null;
};

export const mapDesignRoomDetailsFormModelToDto = (
  formModel: DesignRoomDetailsFormModel,
): CreateUpdateDesignRoomDetailsDto => ({
  unheatedAreaInMetresSquared: assertIsNumberOrNull(formModel.unheatedAreaInMetresSquared),
  voidAreaInMetresSquared: assertIsNumberOrNull(formModel.voidAreaInMetresSquared),
  pipesPerPort: assertIsNumberOrNull(formModel.pipesPerPort),
  manifoldDistanceInMetres: assertIsNumberOrNull(formModel.manifoldDistanceInMetres),
  verticalRunbackInMetres: assertIsNumberOrNull(formModel.verticalRunbackInMetres),
  estimatedLengthOfEachPipeInMetres:
    formModel.estimatedLengthOfEachPipeInMetres == null ? null : round(formModel.estimatedLengthOfEachPipeInMetres, 2),
  drawnLengthInMetres: assertIsNumberOrNull(formModel.drawnLengthInMetres),
  oversupplyLengthInMetres: assertIsNumberOrNull(formModel.oversupplyLengthInMetres),
  peripheralAreaInMetresSquared: assertIsNumberOrNull(formModel.peripheralAreaInMetresSquared),
  turnPanelQuantity: assertIsNumberOrNull(formModel.turnPanelQuantity),
  straightPanelQuantity: assertIsNumberOrNull(formModel.straightPanelQuantity),
  plateAreaInMetresSquared: assertIsNumberOrNull(formModel.plateAreaInMetresSquared),
  hasPanelsForUnheatedArea: formModel.hasPanelsForUnheatedArea,
  temperatureDeltaInDegreesCelsius: assertIsNumberOrNull(formModel.temperatureDeltaInDegreesCelsius),
  maximumTemperatureInDegreesCelsius: assertIsNumberOrNull(formModel.maximumTemperatureInDegreesCelsius),
  screedDetails:
    formModel.screedDetails == null
      ? null
      : {
          screedConductivity: assertIsNumberOrNull(formModel.screedDetails.screedConductivity),
          thicknessOfScreedAbovePipeInMillimetres: assertIsNumberOrNull(
            formModel.screedDetails.thicknessOfScreedAbovePipeInMillimetres,
          ),
        },
});
